import React, { useState } from 'react';

import { useRouter } from 'next/router';

import Button from '@components/common/Button/Button';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';
import AuthenticationPageContext from '@components/lpc/Authentication/AuthenticationPageContext';
import { ROUTE, getRoute } from '@services/http/Route';

import css from './UpdatePasswordConfirmation.module.scss';

const UpdatePasswordConfirmation = () => {
    const { t } = useTranslateLpc('lpc-authentication');

    const [isLoading, setIsLoading] = useState(false);
    const router = useRouter();

    const onRedirection = () => {
        setIsLoading(true);
        router.push(getRoute(ROUTE.LPC.AUTH.SIGN_IN)).then();
    };

    return (
        <AuthenticationPageContext.Consumer>
            {() => (
                <div className={css['email-sent-confirmation']}>
                    <img src="front-static/icons/display/checkmark-outline.svg" alt="checkmark" />
                    <h3>{t('change-password-confirmation.title')}</h3>
                    <br />
                    <Text variant="body_02" color="ui-secondary">
                        {t('change-password-confirmation.details')}{' '}
                    </Text>

                    <Button
                        size="large"
                        variant="primary"
                        isLoading={isLoading}
                        isDisabled={isLoading}
                        margin={'32px 0 0 0'}
                        onClick={() => onRedirection()}
                    >
                        {t('change-password-confirmation.cta')}
                    </Button>
                </div>
            )}
        </AuthenticationPageContext.Consumer>
    );
};
export default UpdatePasswordConfirmation;
